import React, { Component } from "react";
import Tools from '../../tools.js';
import API from '../../api';
// import ReactDOM from "react-dom";
// import Answers from "./Answers";
import Questions from "./Questions";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const getQuestions = count =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        id: `question-${k}`,
        content: `question ${k}`,
        answers: [`answer-1`, `answer-2`, `answer-3`]
    }));

class TestMain extends Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);
        this.state = {
            formData: null,
            isLoading: true,
            pid: this.props.match.params["id"]
        };

        if (this.state.pid) {
            this.getData(this.state.pid);
        } else {
            this.state.isLoading = false;
            this.state.formData = {};
        }
        this.getData = this.getData.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        // this.renderContent = this.renderContent.bind(this);
        this.handleOnUrlChange = this.handleOnUrlChange.bind(this);
    }

    getProjID(hash) {
        const hashList = hash.match(/\/proj\/edit\/(.*)/);
        console.log("!!", hash);
        if (hashList && hashList.length >= 2) return hashList[1];
        return null;
    }

    handleOnUrlChange = (data) => {
        const pid = this.getProjID(data.hash);

        console.log("pid", pid);
        if (pid) {
            this.setState({
                pid: pid
            });
            this.getData(pid);
        } else {
            this.setState({
                pid: pid,
                formData: {}
            });
        }
    }

    getData(pid) {
        console.log(pid, this);
        if (!pid) return;

        API.GetQuestionnaire({
            pi: pid
        })
            .then(response => {
                console.log(response);
                this.setState({
                    isLoading: false,
                });

                if (response && response.responseData) {
                    if (response.responseData.data) {
                        // let proj = response.responseData.data[0];
                        // this.setState({ formData: proj });
                        console.log(response.responseData.data);

                        /*[
                            {
                                //選項
                                op:{},
                                //類型資料...到底寫啥鬼能寫成這樣=_=
                                cf:{
                                    q_type: 1: 單選 2: 複選 3: 下拉 4: 開放 5: 尺規 6: 矩陣 7: 排序 8: 比較 9: 地址
                                },
                                //跳題路徑
                                ru:{

                                },
                                //問題主文
                                ma:{

                                }
                            }
                        ]*/
                        this.setState({
                            formData: getQuestions(response.responseData.data),
                            isLoading: false
                        })
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    onUpdate() {

    }

    render() {
        if (this.isLoading) {
            return (<div>Loading...</div>);
        } else {
            return (<Questions
                formData={this.state.formData}
                onUpdate={this.onUpdate} />);
        }
    }
}
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(TestMain))